import React, { useContext } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { ListContext } from '@contexts/ListContext';

import { getAddressText } from '@components/Addresses/AddressUtils';

const EventAddress = ({ address, inline, showAccess = true }) => {
    if (!address) return null;
    const { GetCountry } = useContext(ListContext);

    const getCountryName = (code) => {
        const country = GetCountry(code);
        return country ? country.Name : code;
    };

    const countryName = address.Country ? getCountryName(address.Country) : '';
    const addressText = getAddressText({
        address,
        countryName,
        inline: Boolean(inline),
        showAccess: showAccess,
    });

    if (!addressText) return null;

    if (inline) {
        return <span className="event-address event-address--inline">{ReactHtmlParser(addressText)}</span>;
    }

    return <div className="event-address">{ReactHtmlParser(addressText)}</div>;
};

export default EventAddress;
